export const SidebarGlobal = {
    setSubNav(children) { },
    clearSubNav() { },
    toggle(on) { },
    success(msg) { },
    warning(msg) { }
};